// PLATFORM-UX-001 — Registro global de operaciones críticas.
// El auto-refresh de versión NUNCA interrumpe una operación activa:
// si busyRegistry.isBusy() → el refresh se difiere hasta quedar idle.
// Tags usados: 'edit-modal' (modal UX-001E abierto), 'product-save'
// (submitting UploadConsole), 'media-upload' (subiendo media), 'checkout'
// (checkout en vuelo). Cualquier flujo futuro que no deba interrumpirse
// adquiere su propio tag.
const active = new Set<string>();
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach(fn => fn());
}

export const busyRegistry = {
  acquire(tag: string) {
    active.add(tag);
    emit();
  },
  release(tag: string) {
    active.delete(tag);
    emit();
  },
  isBusy() {
    return active.size > 0;
  },
  subscribe(fn: () => void): () => void {
    listeners.add(fn);
    return () => { listeners.delete(fn); };
  },
};
